import { useRefreshAuthMutation } from 'apollo/queries/autogenerate/hooks-public';

const useRefreshAuth = () => {
  const [refreshAuthMutation] = useRefreshAuthMutation({
    context: {
      uri: process.env.CONSUMER_API_HOST_GRAPHQL_PUBLIC,
    },
    // Backend needs to update the API to no longer receive a refreshToken because all tokens are stored in HTTPOnly cookies
    // so frontend can no longer access them
    variables: {
      refreshToken: '',
    },
  });

  return refreshAuthMutation;
};

export default useRefreshAuth;
